import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { red } from '@mui/material/colors';

export default function DeleteMessageMenuItem({ onClick }) {
  return (
    <MenuItem onClick={onClick}>
      <ListItemIcon sx={{ color: red[400] }}>
        <DeleteIcon />
      </ListItemIcon>
      <ListItemText sx={{ color: red[400] }}>حذف</ListItemText>
    </MenuItem>
  );
}
